// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Trade_otr .problem_card_otr {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 24px 0;
    grid-gap: 24px;
}
@media (max-width: 575px){
    .Trade_otr .problem_card_otr{
        grid-template-columns: 1fr !important;
    }
}

.problem_card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 16px;
    background-color: transparent;
    border: 1px solid var(--problem-card-border-color);
    gap: 16px;
    height: auto !important;
    cursor: pointer;
    border-radius: 16px;
    -webkit-border-radius: 16px;
    -moz-border-radius: 16px;
    -ms-border-radius: 16px;
    -o-border-radius: 16px;
    transition: .3s;
    -webkit-transition: .3s;
    -moz-transition: .3s;
    -ms-transition: .3s;
    -o-transition: .3s;
}

.problem_card.clicked,
.problem_card:hover {
    background-color: var(--primary-light) !important;
    border: 1px solid var(--primary-color) !important;
}


.problem_card.clicked,
.problem_card:hover {
    color: var(--primary-color) !important;
}

.problem_card .trade_icon_otr {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
}

.problem_card,
.problem_card:hover{
    font-size: 15px;
    font-weight: 500;
    text-align: center;
    line-height: 20px;
    font-family: 'Poppins', sans-serif;
    letter-spacing: 0.00938em;
    color: var(--dark-text-color);
    transition: .3s;
    -webkit-transition: .3s;
    -moz-transition: .3s;
    -ms-transition: .3s;
    -o-transition: .3s;
}`, "",{"version":3,"sources":["webpack://./src/Components/Problem/Trade/Trade.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;AACA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,aAAa;IACb,6BAA6B;IAC7B,kDAAkD;IAClD,SAAS;IACT,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;;IAEI,iDAAiD;IACjD,iDAAiD;AACrD;;;AAGA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,kCAAkC;IAClC,yBAAyB;IACzB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".Trade_otr .problem_card_otr {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: 24px 0;\n    grid-gap: 24px;\n}\n@media (max-width: 575px){\n    .Trade_otr .problem_card_otr{\n        grid-template-columns: 1fr !important;\n    }\n}\n\n.problem_card {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding: 16px;\n    background-color: transparent;\n    border: 1px solid var(--problem-card-border-color);\n    gap: 16px;\n    height: auto !important;\n    cursor: pointer;\n    border-radius: 16px;\n    -webkit-border-radius: 16px;\n    -moz-border-radius: 16px;\n    -ms-border-radius: 16px;\n    -o-border-radius: 16px;\n    transition: .3s;\n    -webkit-transition: .3s;\n    -moz-transition: .3s;\n    -ms-transition: .3s;\n    -o-transition: .3s;\n}\n\n.problem_card.clicked,\n.problem_card:hover {\n    background-color: var(--primary-light) !important;\n    border: 1px solid var(--primary-color) !important;\n}\n\n\n.problem_card.clicked,\n.problem_card:hover {\n    color: var(--primary-color) !important;\n}\n\n.problem_card .trade_icon_otr {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n}\n\n.problem_card,\n.problem_card:hover{\n    font-size: 15px;\n    font-weight: 500;\n    text-align: center;\n    line-height: 20px;\n    font-family: 'Poppins', sans-serif;\n    letter-spacing: 0.00938em;\n    color: var(--dark-text-color);\n    transition: .3s;\n    -webkit-transition: .3s;\n    -moz-transition: .3s;\n    -ms-transition: .3s;\n    -o-transition: .3s;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
